import axios from 'axios'
import type { BrMapping } from '@bloomreach/vue-sdk'
import type { Page } from '@bloomreach/spa-sdk'
import type { TBrand } from '~/ts/types/types'
import { plusComponents } from '@/constants/plusComponents'
import { plushComponents } from '@/constants/plushComponents'
import { buildConfiguration } from '~/utils/buildConfiguration'

export async function useBrxm(): Promise<{
    mapping: BrMapping
    configuration: Record<string, unknown>
    page: Page | undefined
}> {
    const config = useRuntimeConfig()
    const route = useRoute()

    const endpoint = config.public.NUXT_APP_BRXM_ENDPOINT ?? ''
    const baseUrl = config.public.BASE_URL !== '/' ? (config.public.BASE_URL ?? '') : ''
    const hasMultiTenantSupport = config.public.NUXT_APP_BR_MULTI_TENANT_SUPPORT === 'true'

    const configuration = {
        ...buildConfiguration(`${route.fullPath}`, axios, baseUrl as string, endpoint, hasMultiTenantSupport),
    }

    const { data } = await useAsyncData(async (context) => {
        return { page: context?.ssrContext?.event?.node?.req?.pageBody }
    })

    const page = data.value?.page as Page
    const brand = page.channel?.info?.props?.brand as TBrand

    const componentsFlags = config.public.features.plusBlog.components

    const setBrand = {
        plus: plusComponents(componentsFlags),
        plush: plushComponents,
    }
    const mapping = setBrand[brand]
    return { mapping, configuration, page }
}
